import React from 'react';
import './CardIcon.css';

// const CardIcon = ({ src = 'https://via.placeholder.com/50' }) => { // Placeholder image
const CardIcon = ({ src = 'https://obj.tang17so82duytan.com/demo-map//default-icon.png' }) => { // Placeholder image
return (
  <>
    <div className="card-icon">
      <img src={src} alt="User Icon" />
    </div>
    <span className="card-icon-text">nhanlt</span>

  </>
  );
};

export default CardIcon;
